import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RecoilRoot } from "recoil";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { SnackbarProvider } from "notistack";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider maxSnack={10} preventDuplicate>
        <RecoilRoot>
          <RouterProvider router={router} />
          {/* <App /> */}
          {/* <ReactQueryDevtools initialIsOpen={false} />{" "} */}
          {/* 쿼리 개발자도구 */}
        </RecoilRoot>
      </SnackbarProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
